import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'mm_cookie_notice_dismissed_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) {
        // Slight delay so it doesn't jump in on load
        const timer = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(timer);
      }
    } catch (e) {
      // localStorage disabled — just show banner
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // Ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[9998] bg-white border border-gray-200 shadow-2xl rounded-xl p-5"
      role="dialog"
      aria-live="polite"
      aria-label="Datenschutzhinweis"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 flex-shrink-0 rounded-full bg-gray-900 text-white flex items-center justify-center">
          <Cookie size={18} />
        </div>
        <div className="flex-1">
          <h3 className="font-heading text-lg font-semibold mb-1">
            Datenschutz-Hinweis
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            Diese Website verwendet ausschließlich technisch notwendige Speichermechanismen. Es werden keine Tracking-, Marketing- oder Analyse-Cookies eingesetzt. Details finden Sie in der{' '}
            <a
              href="/datenschutz"
              className="text-primary underline hover:no-underline"
              data-testid="cookie-banner-privacy-link"
            >
              Datenschutzerklärung
            </a>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={dismiss}
              data-testid="cookie-banner-accept-btn"
              className="btn-primary text-sm px-4 py-2"
            >
              Verstanden
            </button>
            <a
              href="/datenschutz"
              className="text-sm px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
              data-testid="cookie-banner-more-btn"
            >
              Mehr erfahren
            </a>
          </div>
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Hinweis schließen"
          data-testid="cookie-banner-close-btn"
          className="text-gray-400 hover:text-gray-700 transition-colors -m-1 p-1"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
